import { t } from "@repo/translation";

export const getProjectTourSteps = () => {
  return [
    {
      disableBeacon: true,
      target: "ul > li:nth-child(1)",
      content: t("tour.projects_overview.step1"),
    },
    {
      target: "ul > li:nth-child(2)",
      content: t("tour.projects_overview.step2"),
    },
    {
      target: "#tour-sales-lead-filters",
      content: t("tour.projects_overview.step3"),
    },
    {
      target: "#tour-sales-lead-coworker-picker",
      content: t("tour.projects_overview.step4"),
    },
    {
      target: "#tour-search-field",
      content: t("tour.projects_overview.step5"),
    },
    {
      target: "#popper-portal input[type='radio']",
      content: t("tour.projects_overview.step6"),
    },
    {
      target: "#popper-portal input[type='checkbox']",
      content: t("tour.projects_overview.step7"),
    },
    {
      target: "#tour-assigned-coworkers",
      content: t("tour.projects_overview.step8"),
    },
  ];
};
